(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vicio-offer-strip"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vicio-offer-strip')) customElements.define('vicio-offer-strip', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const parsedEnd = Date.parse(this.dataset.end);
    const anchor = Number.isFinite(parsedEnd) ? parsedEnd : Date.parse('2026-10-22T06:19:39Z');
    const cycle = 10 * 60 * 60 * 1000;
    let displayedEnd;
    this.hidden = false;
    const tick = () => {
      const now = Date.now();
      const remaining = ((anchor - now) % cycle + cycle) % cycle || cycle;
      const total = Math.ceil(remaining / 1000);
      const end = now + remaining;
      if (end !== displayedEnd) {
        displayedEnd = end;
        this.querySelector('time').dateTime = new Date(end).toISOString();
        this.querySelector('[data-deadline]').textContent = new Date(end).toLocaleString(document.documentElement.lang || 'es', {timeZone:'Europe/Madrid',timeZoneName:'short'});
      }
      this.querySelector('[data-hours]').textContent = String(Math.floor(total / 3600)).padStart(2,'0');
      this.querySelector('[data-minutes]').textContent = String(Math.floor(total % 3600 / 60)).padStart(2,'0');
      this.querySelector('[data-seconds]').textContent = String(total % 60).padStart(2,'0');
    };
    tick();
    this.timer = setInterval(tick,1000);
    this.querySelector('[data-pause]').onclick = event => {
      const paused = !this.hasAttribute('data-paused');
      this.toggleAttribute('data-paused',paused);
      event.currentTarget.setAttribute('aria-pressed',String(paused));
    };
  }
  disconnectedCallback() { clearInterval(this.timer); this.ready = false; }
});
  } catch(e) { console.error(e); }
})();

})();
